$(document).ready(function() {
    $dynamicHeaderLinks = $('<div />').prop('id', 'dynamicHeaderLinks').append('<a href="https://www.land-oberoesterreich.gv.at/" target="_blank"><img src="/fileadmin/projects/landesholding/images/oberoesterreich_wappen.png" title="Land Oberösterreich – Startseite (neues Fenster)" alt="Land Oberösterreich – Startseite (neues Fenster)" /></a>');

    $('.ttgLogoMenuContainer .ttgLogo').closest('.row').append($dynamicHeaderLinks);

    // Cookie Consent => Analyse, Marketing und Personalisierung ausblenden (LANDESHOLD-74)
    $('.ttgCookieType').each(function(index) {
        if (index > 0) {
            $(this).remove();
        }
    });
    // Buttons und Impressum entfernen
    $('.cc-impressum').remove();
    $('.cc-compliance .cc-deny').remove();
    $('.cc-acceptEverything').remove();

    // Speichern Button umbenennen
    $('.ttgCookieConsentSheet2 .cc-allow').text('Weiter');
});